import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import isEmpty from "../../validation/is-empty";
import Moment from "react-moment";
import Neigbourhoods from "./Neigbourhoods";
import HotCities from "./HotCities";

import Spinner from "../common/Spinner";
import { getPosts } from "../../actions/postActions";
import { useDispatch, useSelector } from "react-redux";
import { Accordion, Button, Card } from "react-bootstrap";
import { brussels } from "../../data/brussels.utils";
import { paris } from "../../data/paris.utils";
import { londons } from "../../data/londons.utils";
import { dublins } from "../../data/dublins.utils";

//import { hotCities } from "../../settings/profiles/profilesItem.utils";

//import store from "../../store";

const ProfileItem = (props) => {
  const { profile, loading } = props;
  const post = useSelector((state) => state.post);
  const { posts } = post;

  //switch to hot cities
  const [hotCities, setHotCities] = useState([]);
  const [isNoHotCities, setNoHotCities] = useState(true);
  const [isBrussels, setBrussels] = useState(false);
  const [isParis, setParis] = useState(false);
  const [isLondon, setLondon] = useState(false);
  const [isDublin, setDublin] = useState(false);

  const switchToBrussels = () => {
    setBrussels(!isBrussels);
    setParis(false);
    setLondon(false);
    setDublin(false);
    setNoHotCities(false);
    setHotCities(brussels);
  };
  const switchToParis = () => {
    setParis(!isParis);
    setBrussels(false);
    setLondon(false);
    setDublin(false);
    setNoHotCities(false);
    setHotCities(paris);
  };
  const switchToLondon = () => {
    setLondon(!isLondon);
    setParis(false);
    setBrussels(false);
    setDublin(false);
    setNoHotCities(false);
    setHotCities(londons);
  };
  const switchToDublin = () => {
    setDublin(!isDublin);
    setParis(false);
    setLondon(false);
    setBrussels(false);
    setNoHotCities(false);
    setHotCities(dublins);
  };

  const switchToNoHotCities = () => {
    setNoHotCities(!isNoHotCities);
    setParis(false);
    setLondon(false);
    setDublin(false);
    setBrussels(false);
    setHotCities([]);
  };

  //const posts = store.getState().post.posts;
  // const profile = useSelector((state) => state.profile);

  // let filteredPosts = posts.filter((el) => {
  //   return profile.skills.some((f) => {
  //     return f === el.level;
  //   });
  // });

  // let filteredHotcities = hotCities.filter((el) => {
  //   return profile.skills.some((f) => {
  //     return f === el.neigbourhood;
  //   });
  // });

  let filteredHotcities = hotCities;

  console.log("val_hotCities", hotCities);
  console.log("val_filteredHotcities", filteredHotcities);
  let filteredPosts = posts.filter((el) => {
    return profile.skills.some((f) => {
      return f.toLowerCase() === el.level.toLowerCase();
    });
  });
  // let filteredPosts = posts.filter((el) => profile.skills.includes(el.level));
  // let filteredPosts =
  //   posts &&
  //   posts.filter((post) =>
  //     profile.skills.includes(Object.values(post).join("").toLowerCase())
  //   );

  console.log("val_post", posts);
  console.log("vaö_filterposts", filteredPosts);

  let postContent;
  let brusselContent;
  let pariContent;
  let londonContent;
  let dublinContent;

  if (posts === null || loading) {
    postContent = <Spinner />;
  } else {
    postContent = filteredPosts.map((post) => (
      <Neigbourhoods key={post._id} post={post} />
    ));
  }

  //brussel
  if ((isBrussels === true && brussels === null) || loading) {
    brusselContent = <Spinner />;
  } else {
    brusselContent = filteredHotcities.map((hotCitie) => (
      <HotCities key={hotCitie.ll_id} hotCitie={hotCitie} />
    ));
    console.log("val_brusselContent", brusselContent);
  }

  //paris
  if ((isParis === true && paris === null) || loading) {
    pariContent = <Spinner />;
  } else {
    pariContent = filteredHotcities.map((hotCitie) => (
      <HotCities key={hotCitie.ll_id} hotCitie={hotCitie} />
    ));
    console.log("val_pariContent", pariContent);
  }

  //london
  if ((isLondon === true && londons === null) || loading) {
    londonContent = <Spinner />;
  } else {
    londonContent = filteredHotcities.map((hotCitie) => (
      <HotCities key={hotCitie.ll_id} hotCitie={hotCitie} />
    ));
    console.log("val_londonContent", londonContent);
  }

  //dublin
  if ((isDublin === true && dublins === null) || loading) {
    dublinContent = <Spinner />;
  } else {
    dublinContent = filteredHotcities.map((hotCitie) => (
      <HotCities key={hotCitie.ll_id} hotCitie={hotCitie} />
    ));
    console.log("val_dublinContent", dublinContent);
  }

  console.log("val_posts", postContent);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPosts());
  }, [dispatch]);

  return (
    <div className=" container ">
      <div className="mb-3 rounded row col-lg-6 justify-content-between d-flex flex-lg-nowrap flex-md-nowrap flex-sm-wrap  ">
        <div className="col-md-2 col-sm-12 bg-dark  d-none d-md-block d-lg-block">
          <img
            src={profile && profile.user ? profile.user.avatar : ""}
            alt=""
            className="rounded-circle"
          />

          <p className="text-info  ">
            <small>
              Joined Ici apart-&-rooms <br />
              <em>
                <Moment fromNow>{profile.date}</Moment>{" "}
              </em>
            </small>
          </p>
        </div>
        <div className="col-lg-6 col-md-4 text-center col-sm-12 shadow-lg p-lg-3 mb-lg-3 pb-sm-2 mb-sm-2 bg-body border border-info border-rounded rounded">
          <h3>{profile && profile.user ? profile.user.name : null}</h3>
          <p className="text-info">
            <em>
              Looking for a room in <strong>{profile.status} </strong> ||
              Domiciliation:
              {isEmpty(profile.company) ? null : (
                <span>{profile.company}</span>
              )}{" "}
            </em>{" "}
          </p>
          {profile.totalExp ? <p>Min Stay: {profile.totalExp}</p> : null}

          {isEmpty(profile.maxbudget) ? null : (
            <p>
              <span>
                {" "}
                Max budget:<strong> {profile.maxbudget}€ </strong>
              </span>
            </p>
          )}

          <p>
            {isEmpty(profile.location_city) ? null : (
              <span>{profile.location_city}</span>
            )}
            {profile.location_city ? "," : null}
            {isEmpty(profile.location_country) ? null : (
              <span>{profile.location_country}</span>
            )}
          </p>

          <Link
            to={`/profile/${profile.handle}`}
            className="btn bg-info text-white shadow-lg shadow-md p-2 mb-2  rounded border border-dark mb-2"
          >
            <h6> View Mission</h6>
          </Link>
        </div>
        <div
          className="col-md-4 bg-info   "
          style={{
            textAlign: "center",
            borderTopRightRadius: "10%",
            borderBottomRightRadius: "25%",
          }}
        >
          <h6 className="pt-2 m-1 " style={{ fontSize: "12px" }}>
            {" "}
            <strong>Neigbourhoods</strong>
          </h6>
          <ul
            className="list-group text-center bg-dark"
            style={{ zIndex: 6, textAlign: "center" }}
          >
            {profile.skills.slice(0, 5).map((skill, index) => (
              <li key={index} className="list-group-item bg-transparent ">
                <span className="badge badge-sm-small badge-pill bg-info text-white badge-outline-info border border-info b-2 h-sm-10 text-center ">
                  <div>
                    <i className="fa fa-check" />
                    {skill}
                  </div>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="overflow-auto col-sm-12 bg-dark shadow-lg shadow-md p-2  border border-pink "
          style={{
            flexDirection: "column",
            borderTopLeftRadius: "10%",
            borderBottomLeftRadius: "25%",
          }}
        >
          <div className="card card-info bg-transparent">
            <Accordion
              className="bg-info - shadow shadow-info "
              style={{
                borderTopLeftRadius: "25%",
                borderBottomLeftRadius: "25%",
              }}
            >
              <Accordion.Toggle as={Button} variant="link" eventKey="0">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignText: "center",
                  }}
                >
                  <div className="card-header badge badge-medium text-white text-center">
                    Switch to Hot Properties
                  </div>

                  <i className="fa fa-solid fa-sort-down text-white text-right "></i>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <div className="card-body d-flex flex-row flex-wrap ">
                    <span
                      onClick={() => switchToBrussels()}
                      className="badge bg-dark mr-1 text-white border border-2 border-white"
                      style={{ cursor: "pointer" }}
                    >
                      Brussels
                    </span>
                    <span
                      onClick={() => switchToParis()}
                      className="badge bg-dark mr-1 text-white border border-2 border-white"
                      style={{ cursor: "pointer" }}
                    >
                      Paris
                    </span>
                    <span
                      onClick={() => switchToLondon()}
                      className="badge bg-dark mr-1 text-white border border-2 border-white"
                      style={{ cursor: "pointer" }}
                    >
                      London
                    </span>
                    <span
                      onClick={() => switchToDublin()}
                      className="badge bg-dark mr-1 text-white border border-2 border-white"
                      style={{ cursor: "pointer" }}
                    >
                      Dublin
                    </span>

                    <span
                      onClick={() => switchToNoHotCities()}
                      className="badge bg-dark mr-1 text-white border border-2 border-white"
                      style={{ cursor: "pointer" }}
                    >
                      Close
                    </span>
                  </div>
                </Card.Body>
              </Accordion.Collapse>
            </Accordion>
          </div>
          <div
            className="conatainer  "
            style={{ overflow: "auto", height: "350px" }}
          >
            {isNoHotCities && postContent}
            {isBrussels && brusselContent}
            {isParis && pariContent}
            {isLondon && londonContent}
            {isDublin && dublinContent}
          </div>
        </div>
      </div>
    </div>
  );
};

ProfileItem.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default ProfileItem;
